import styled from "styled-components";

import WidgetBox from "./WidgetBox";

const PrimaryWidgetBox = styled(WidgetBox)`
  background: ${props => props.theme.colors.white};
`;
PrimaryWidgetBox.displayName = "UIPrimaryWidgetBox";

export default PrimaryWidgetBox;
